// src/components/RequireAdminAuth.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

interface RequireAdminAuthProps {
  children: React.ReactNode;
}

const RequireAdminAuth: React.FC<RequireAdminAuthProps> = ({ children }) => {
  const { adminToken } = useAdminAuth();
  const location = useLocation();

  if (!adminToken) {
    // redireciona para o login de admin, guardando a rota atual
    return <Navigate to="/rj/admin-login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default RequireAdminAuth;
